<template>
  <div>
    <SurveyForm :config="formattedSurveyConfig" @onSubmit="handleSubmit" />
    <div class="text-center">
      <FormError v-if="!!error" :text="error" />
    </div>
  </div>
</template>

<script>
import surveyFormMixin from '@platform-shared/mixins/health-actions/surveyFormMixin.js'
import SurveyForm from '../../SurveyForm.vue'
import FormError from '../../../../common/forms/FormError.vue'

export default {
  components: {
    SurveyForm,
    FormError,
  },
  mixins: [surveyFormMixin],
}
</script>
